<div id="imprint-page" class="container me-landing-page-imprint" *ngIf="data">
    <a class="btn btn-link btn-icon btn-icon--left btn-back btn--secondary"
       [routerLink]="['/me']">
        {{ 'back' | translate }}
    </a>
    <div class="me-landing-page-imprint__title">
        {{data.title}}
    </div>
    <div class="me-landing-page-imprint__navigator">
        <ng-container *ngFor="let content of data['titledParagraph']; let  i = index">
            <span (click)="scrollToElement(content._uid)">{{i + 1}}. {{content.title}}</span>
        </ng-container>
    </div>
    <div id="{{content._uid}}" class="me-landing-page-imprint__body"
         *ngFor="let content of data['titledParagraph']; let  i = index">
        <div class="me-landing-page-imprint__body__title">{{i + 1}}. {{content.title}}</div>
        <div class="me-landing-page-imprint__body__content" [innerHTML]="content.paragraph | storyblokRichtext"></div>
    </div>

    <button class="btn btn-link btn-icon btn-icon--left btn--secondary " (click)="toTop()">
        <i class="far fa-arrow-up"></i>
        {{ 'Back to top' | translate }}
    </button>
</div>